import * as React from 'react';
import { useState } from 'react';
import styled from 'styled-components';

export interface Props {
  url: string;
  size: string;
  placeholderSvgXmlData: string;
}

interface PlaceholderProps {
  display: boolean;
  loaded: boolean;
  size: string;
  placeholderSvgXmlData: string;
}

interface ImageProps {
  size: string;
  loaded: boolean;
}

const Root = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: ${(props: Props) => props.size};
  padding: 1.5rem 0;
`;

const ImagePlaceholder = styled.div`
  display: ${(props: PlaceholderProps) => props.loaded ? 'none' : 'block'};
  width: ${(props: PlaceholderProps) => props.size};
  height: 100%;
  background-image: ${(props: Props) => `url('${props.placeholderSvgXmlData}')`};
  background-color: #777;
  background-size: 80%;
  background-position: center;
  background-repeat: no-repeat;
  flex: 0 0 auto;
  position: absolute;
  transition: opacity 750ms;
  `;

const Image = styled.img`
  width: ${(props: ImageProps) => props.size};
  background-color: #777;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: ${(props: ImageProps) => props.loaded ? 'block' : 'none'};
  flex: 0 0 auto;
  position:absolute;
`;

export const ImagePreview = (props: Props) => {
  const { size, url } = props;
  const [loaded, setLoaded] = useState(false);
  const [transitionEnded, setTransitionEnded] = useState(false);

  return (
    <Root size={size}>
      <Image
        onLoad={() => setLoaded(true)}
        src={url}
        size="4rem"
        loaded={loaded}
      />
      <ImagePlaceholder
        loaded={loaded}
        size="4rem"
        onTransitionEnd={() => setTransitionEnded(true)}
        placeholderSvgXmlData={props.placeholderSvgXmlData}
        hide={transitionEnded}
      />
    </Root>
  );
};
